import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { PreferenceSetEntity } from './preference-set.entity';
import { PreferenceEntity } from './preference.entity';
import { RbacRoleEntity } from './rbac-role.entity';

@Index('_fk__preference__id', ['fkPreferenceId'], {})
@Index('_fk__preference_set__id_default', ['fkPreferenceSetIdDefault'], {})
@Index('_fk__rbac_role__id', ['fkRbacRoleId'], {})
@Index(
	'unique_rbac_role_preference',
	['fkRbacRoleId', 'fkPreferenceId', 'fkObjectIdReference', 'referenceId'],
	{ unique: true },
)
@Entity('_preference__rbac_role')
export class PreferenceRbacRoleEntity extends BaseEntity {
	@Column('int', { name: '_fk__rbac_role__id', nullable: true, unsigned: true })
	public fkRbacRoleId!: number | null;

	@Column('int', {
		name: '_fk__preference__id',
		nullable: true,
		unsigned: true,
	})
	public fkPreferenceId!: number | null;

	@Column('int', {
		name: '_fk__preference_set__id_default',
		nullable: true,
		unsigned: true,
	})
	public fkPreferenceSetIdDefault!: number | null;

	@Column('int', {
		name: '_fk__object__id_reference',
		unsigned: true,
		default: () => "'0'",
	})
	public fkObjectIdReference!: number;

	@Column('int', { name: '_referenceId', unsigned: true, default: () => "'0'" })
	public referenceId!: number;

	@ManyToOne(() => RbacRoleEntity, (rbacRole) => rbacRole.preferenceRbacRoles, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__rbac_role__id', referencedColumnName: 'id' }])
	public fkRbacRole!: RbacRoleEntity;

	@ManyToOne(
		() => PreferenceEntity,
		(preference) => preference.preferenceRbacRoles,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk__preference__id', referencedColumnName: 'id' }])
	public fkPreference!: PreferenceEntity;

	@ManyToOne(
		() => PreferenceSetEntity,
		(preferenceSet) => preferenceSet.preferenceRbacRoles,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk__preference_set__id_default', referencedColumnName: 'id' },
	])
	public fkPreferenceSetIdDefault2!: PreferenceSetEntity;
}
